let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ZGtxl")).then(() => parcelRequire('cN0bp'));